import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { authInstance, publicInstance } from "apis";
import authAtom from "stores/auth";
import Auth from "types/Auth";

// 모바일 체크 커스텀 훅
const useCheckToken = () => {
  const setAuth = useSetRecoilState(authAtom);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("TOKEN");

  useEffect(() => {
    checkToken();
  }, []);

  const login = (type: Auth["type"]) => {
    authInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    setAuth({
      type,
      isLogin: true,
    });

    setIsLoading(false);
  };

  const getMe = async (path: string) => {
    try {
      await publicInstance.get(path, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return true;
    } catch {
      return false;
    }
  };

  const checkToken = async () => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    const userMe = await getMe("/user/me");

    if (userMe) {
      login("user");
    } else {
      const companyMe = await getMe("/company/me");

      if (!companyMe) {
        localStorage.removeItem("TOKEN");
        setAuth({
          type: "",
          isLogin: false,
        });
        setIsLoading(false);
        window.location.href = "/login";
        return;
      }

      login("company");
    }
  };

  return isLoading;
};

export default useCheckToken;
